//= Functions & Modules
// Others
import React from 'react';

//= React components
// Others
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

type Props = {
    label: string;
    href: string;
    icon?: IconDefinition;
};

export class MenuOption extends React.PureComponent<Props> {
    render() {
        return (
            <NavLink
                to={this.props.href}
                className={({ isActive }) =>
                    `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                        isActive
                            ? 'text-title bg-selected font-medium'
                            : 'text-unselected1 hover:text-unselected2 hover:bg-white/[0.04]'
                    }`
                }
            >
                {this.props.icon && (
                    <FontAwesomeIcon icon={this.props.icon} className="w-4 text-center" fixedWidth />
                )}
                <span>{this.props.label}</span>
            </NavLink>
        );
    }
}
